import { OvFormProvider, PageWrapper } from '@components'
import { LABELS, TOOLTIPS } from '@constants'
import { useStore } from '@hooks/useStore'
import { Button, Tooltip } from '@mui/material'
import { IUser } from '@typings'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { FieldValues, useForm } from 'react-hook-form'
import { ProfileForm } from 'src/partials/forms/profile/profile-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { profileValidationSchema } from 'src/partials/forms/account/validation/profile.form.validation'
import { useTranslation } from 'react-i18next'

export const ProfileView = observer(() => {
  const { user, ui } = useStore()
  const { t } = useTranslation()

  const form = useForm({
    resolver: yupResolver(profileValidationSchema()),
    mode: 'onChange',
    defaultValues: {
      name: user.current_user?.name,
    },
  })

  const handleSuccess = (data: IUser) => {
    form.reset(data)
    ui.handleToaster(t('changes_saved'), { type: 'success' })
  }

  const onSubmitCallBack = async (data: FieldValues) => {
    await user.update(data as IUser).then(res => handleSuccess(res))
  }

  const handleSubmit = () => {
    form.handleSubmit(onSubmitCallBack)
  }

  // Fetch user data on mount to get latest info including pending_email_change
  useEffect(() => {
    user.whoAmI()
  }, [])

  return (
    <OvFormProvider
      loading={user.loading}
      form={form}
      onSubmit={handleSubmit}>
      <PageWrapper
        pageTitle={LABELS.MY_PROFILE}
        loading={user.loading}
        actions={
          <Tooltip title={TOOLTIPS.SAVE_PROFILE}>
            <Button
              variant="contained"
              type="submit"
              disabled={!form.formState.isDirty || form.formState.isSubmitting}
              sx={{ width: { xs: '100%', sm: 'auto' } }}>
              Opslaan
            </Button>
          </Tooltip>
        }>
        <ProfileForm />
      </PageWrapper>
    </OvFormProvider>
  )
})
